import React from "react";
import { pnf } from "../assets";
import Footer from "../components/home/common/Footer";
import { useNavigate } from "react-router-dom";
import { FaAngleLeft } from "react-icons/fa";

const PageNotFound = () => {
  const navigate = useNavigate();
  return (
    <section className="p-6">
      <div className="">
        <button
          className="flex justify-center items-center max-w-[100px]"
          onClick={() => navigate(-1)}
        >
          <FaAngleLeft className="text-secondary" />
          <span className="text-secondary text-[24px] font-semibold pl-1">
            Back
          </span>
        </button>
      </div>
      <img src={pnf} className="h-[100%] object-contain" alt="pnf" />
      <Footer />
    </section>
  );
};

export default PageNotFound;
